import createTypeDecorator from '../decorators/createTypeDecorator'
// import {
//   validateDateTimeString,
// } from 'pw-validators'

export const DAY = Symbol("schemer.types.DAY")
export const TIME = Symbol("schemer.types.TIME")
export const DATETIME = Symbol("schemer.types.DATETIME")
export const DURATION_MS = Symbol("schemer.types.DURATION_MS")

export const day = createTypeDecorator(DAY, {
  // TODO: Date/Time default formatting defaults can be changed globally via Schema Preferences
  formatDisplay: val => {
    return val && new Date(val).toLocaleString().replace(/,/g, '')
  },
  input: {
    // validate: validateDateTimeString
  },
  table: {
    width: 200
  }
})

export const time = createTypeDecorator(TIME, {
  // TODO: Date/Time default formatting defaults can be changed globally via Schema Preferences
  formatDisplay: val => {
    return `time(${val})`
  },
  input: {
    // validate: validateDateTimeString
  },
  table: {
    width: 200
  }
})

export const datetime = createTypeDecorator(DATETIME, {
  // TODO: Date/Time default formatting defaults can be changed globally via Schema Preferences
  formatDisplay: val => {
    return val && new Date(val).toLocaleString().replace(/,/g, '')
  },
  input: {
    // validate: validateDateTimeString
  },
  table: {
    width: 300
  }
})

export const durationMs = createTypeDecorator(DURATION_MS, {
  // TODO: Date/Time default formatting defaults can be changed globally via Schema Preferences
  formatDisplay: val => {
    return `${val} milliseconds`
  },
  input: {
    // validate: validateNumber
  },
  table: {
    width: 200
  }
})